module.exports = __webpack_public_path__ + "media/images/flags/GL-07ae77573c19686b8ffe8ff9c7503237.svg";